import { render } from "./DeveloperCellBadge.vue?vue&type=template&id=053708c6"
import script from "./DeveloperCellBadge.vue?vue&type=script&lang=js"
export * from "./DeveloperCellBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__